/* eslint-disable no-console */
import { ILogger } from './ILogger';

export const consoleLogger: ILogger = {
    log: console.log,
    warn: console.warn,
    error: console.error
};
